import { inject, Injectable } from '@angular/core';

import { QueryParamSynchronizer } from '~core/utils/query-param-synchronizer';
import { QueryParamSynchronizerField } from '~core/utils/query-param-synchronizer-field';
import { QueryParamsService } from './query-params.service';

@Injectable({
    providedIn: 'root'
})
export class QueryParamSyncService {
    private readonly queryParamsService = inject(QueryParamsService);

    createQueryParamSynchronizer<T extends object>(
        fieldsToSync: QueryParamSynchronizerField<T>[],
        onQueryParamsChanged: (data: Partial<T>) => void
    ): QueryParamSynchronizer<T> {
        return new QueryParamSynchronizer<T>(fieldsToSync, onQueryParamsChanged, this.queryParamsService);
    }
}
